import React, { Component } from "react";
import DOMPurify from "dompurify";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SEO from "../../components/shared/SEO";
import CartWidget from "../../components/shared/CartWidget";
import CategoriesWidget from "../../components/shared/CategoriesWidget";
import BlogWidget from "../../components/shared/BlogWidget";
import VibrantProductCard from "../../components/VibrantProductCard";
import Loading from "../../components/shared/Loading";
import activeDiscount from "../../helpers/activeDiscount";
import {
  setProduct,
  getProductBySlug,
  getSimilarProducts,
} from "../../store/actions/product";
import { addCart } from "../../store/actions/cart";
import { PUBLIC_URL } from "../../config";
import { Link } from "react-router-dom";
import {
  generatePageTitle,
  generateMetaDescription,
  generateKeywords,
  generateBreadcrumbs,
  generateCanonicalUrl,
  generateAltText,
} from "../../helpers/seo";
import { trackViewItem, trackAddToCart } from "../../utils/analytics";
import { trackProductView as trackProductViewBackend } from "../../utils/cartSync";

class Product extends Component {
  state = {
    selectedImage: "",
    selectedImageIndex: 0,
    quantity: 1,
    lightbox: false,
    activeImageIndex: 0,
  };

  constructor(props) {
    super(props);
    this.lightboxRef = React.createRef();
  }

  componentDidMount() {
    if (this.props.location.state && this.props.location.state.product) {
      this.props.setProduct(this.props.location.state.product, (img) => {
        this.setState({ selectedImage: img, activeImageIndex: 0 });
      });
      this.loadSimilarProducts(this.props.location.state.product);
      this.trackProductView(this.props.location.state.product);
    } else {
      this.props.getProductBySlug(this.props.match.params.slug, (img) => {
        this.setState({ selectedImage: img, activeImageIndex: 0 });
      });
    }
  }

  componentDidUpdate(prevProps) {
    // Check if URL slug has changed
    if (prevProps.match.params.slug !== this.props.match.params.slug) {
      // Reset state when slug changes
      this.setState({
        selectedImage: "",
        selectedImageIndex: 0,
        activeImageIndex: 0,
        quantity: 1,
      });

      // Fetch new product data
      this.props.getProductBySlug(this.props.match.params.slug, (img) => {
        this.setState({ selectedImage: img, activeImageIndex: 0 });
      });

      // Scroll to top
      window.scrollTo(0, 0);
      return;
    }

    if (!prevProps.product.product && this.props.product.product) {
      this.loadSimilarProducts(this.props.product.product);
      this.trackProductView(this.props.product.product);
    }

    if (prevProps.location.state) {
      if (this.props.location.state && this.props.location.state.product) {
        if (
          prevProps.location.state.product !== this.props.location.state.product
        ) {
          this.props.setProduct(this.props.location.state.product, (img) => {
            this.setState({ selectedImage: img }, () => {
              window.scrollTo(0, 180);
            });
          });
          this.loadSimilarProducts(this.props.location.state.product);
          this.trackProductView(this.props.location.state.product);
        }
      }
    }
  }

  loadSimilarProducts = (product) => {
    if (
      product &&
      product.id &&
      product.categories &&
      product.categories.length > 0
    ) {
      const categoryIds = product.categories.map((cat) => cat.id);
      this.props.getSimilarProducts(product.id, categoryIds);
    }
  };

  trackProductView = (product) => {
    if (product && product._id) {
      // Track for Google Analytics
      trackViewItem(product);

      // Track for backend analytics
      trackProductViewBackend(product._id);
    }
  };

  handleQuantityChange = (type) => {
    const { quantity } = this.state;
    const { product } = this.props.product;
    if (type === "increase" && quantity < product.stock) {
      this.setState({ quantity: quantity + 1 });
    } else if (type === "decrease" && quantity > 1) {
      this.setState({ quantity: quantity - 1 });
    }
  };

  handleAddToCart = () => {
    const { product } = this.props.product;
    const { quantity } = this.state;

    // Check if product can be added to cart
    if (!product.stock || product.stock === 0) {
      alert("Bu ürün stokta bulunmamaktadır.");
      return;
    }

    if (!product.price || product.price === 0) {
      alert("Bu ürün için fiyat belirtilmemiştir.");
      return;
    }

    // Analytics tracking - ürün detay sayfasından sepete ekleniyor
    trackAddToCart(product, quantity);

    // Use the same logic as VibrantProductCard
    this.props.addCart(product, quantity);
  };

  selectImage = (image, index) => {
    this.setState({
      selectedImage: image,
      selectedImageIndex: index,
      activeImageIndex: index,
    });
  };

  openLightbox = () => {
    this.setState({ lightbox: true });
    document.body.style.overflow = "hidden";
  };

  closeLightbox = () => {
    this.setState({ lightbox: false });
    document.body.style.overflow = "auto";
  };

  renderLightbox() {
    if (!this.state.lightbox) return null;

    const { product } = this.props.product;
    const allImages = [];
    if (product.image) {
      allImages.push(product.image);
    }
    if (product.images && Array.isArray(product.images)) {
      product.images.forEach((img) => {
        if (img && img !== product.image) {
          allImages.push(img);
        }
      });
    }
    const productImages = allImages.length > 0 ? allImages : [product.image];

    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.95)",
          zIndex: 999999999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "20px",
        }}
        onClick={this.closeLightbox}
      >
        {/* Previous Button */}
        {productImages.length > 1 && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              const currentIndex = productImages.findIndex(
                (img) => img === this.state.selectedImage
              );
              const prevIndex =
                currentIndex > 0 ? currentIndex - 1 : productImages.length - 1;
              this.setState({
                selectedImage: productImages[prevIndex],
                activeImageIndex: prevIndex,
              });
            }}
            style={{
              position: "absolute",
              left: "20px",
              top: "50%",
              transform: "translateY(-50%)",
              background: "rgba(0, 0, 0, 0.7)",
              border: "2px solid rgba(255, 255, 255, 0.3)",
              borderRadius: "50%",
              color: "white",
              fontSize: "24px",
              cursor: "pointer",
              zIndex: 999999999,
              width: "60px",
              height: "60px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.background = "rgba(255, 255, 255, 0.2)";
              e.target.style.borderColor = "rgba(255, 255, 255, 0.6)";
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "rgba(0, 0, 0, 0.7)";
              e.target.style.borderColor = "rgba(255, 255, 255, 0.3)";
            }}
          >
            ‹
          </button>
        )}

        {/* Main Image */}
        <img
          src={PUBLIC_URL(this.state.selectedImage)}
          alt={product && product.name}
          style={{
            maxWidth: "80%",
            maxHeight: "80%",
            objectFit: "contain",
          }}
          onClick={(e) => e.stopPropagation()}
        />

        {/* Next Button */}
        {productImages.length > 1 && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              const currentIndex = productImages.findIndex(
                (img) => img === this.state.selectedImage
              );
              const nextIndex =
                currentIndex < productImages.length - 1 ? currentIndex + 1 : 0;
              this.setState({
                selectedImage: productImages[nextIndex],
                activeImageIndex: nextIndex,
              });
            }}
            style={{
              position: "absolute",
              right: "20px",
              top: "50%",
              transform: "translateY(-50%)",
              background: "rgba(0, 0, 0, 0.7)",
              border: "2px solid rgba(255, 255, 255, 0.3)",
              borderRadius: "50%",
              color: "white",
              fontSize: "24px",
              cursor: "pointer",
              zIndex: 999999999,
              width: "60px",
              height: "60px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.background = "rgba(255, 255, 255, 0.2)";
              e.target.style.borderColor = "rgba(255, 255, 255, 0.6)";
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "rgba(0, 0, 0, 0.7)";
              e.target.style.borderColor = "rgba(255, 255, 255, 0.3)";
            }}
          >
            ›
          </button>
        )}

        {/* Close Button */}
        <button
          onClick={this.closeLightbox}
          style={{
            position: "absolute",
            top: "20px",
            right: "20px",
            background: "rgba(0, 0, 0, 0.7)",
            border: "2px solid rgba(255, 255, 255, 0.3)",
            borderRadius: "50%",
            color: "white",
            fontSize: "24px",
            cursor: "pointer",
            zIndex: 999999999,
            width: "50px",
            height: "50px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "all 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.target.style.background = "rgba(220, 53, 69, 0.8)";
            e.target.style.borderColor = "rgba(220, 53, 69, 0.8)";
          }}
          onMouseLeave={(e) => {
            e.target.style.background = "rgba(0, 0, 0, 0.7)";
            e.target.style.borderColor = "rgba(255, 255, 255, 0.3)";
          }}
        >
          ×
        </button>

        {/* Image Counter */}
        {productImages.length > 1 && (
          <div
            style={{
              position: "absolute",
              bottom: "30px",
              left: "50%",
              transform: "translateX(-50%)",
              background: "rgba(0, 0, 0, 0.7)",
              color: "white",
              padding: "8px 16px",
              borderRadius: "20px",
              fontSize: "14px",
              fontWeight: "500",
              border: "1px solid rgba(255, 255, 255, 0.3)",
            }}
          >
            {productImages.findIndex(
              (img) => img === this.state.selectedImage
            ) + 1}{" "}
            / {productImages.length}
          </div>
        )}

        {/* Thumbnail Strip */}
        {productImages.length > 1 && (
          <div
            style={{
              position: "absolute",
              bottom: "80px",
              left: "50%",
              transform: "translateX(-50%)",
              display: "flex",
              gap: "8px",
              padding: "10px",
              background: "rgba(0, 0, 0, 0.5)",
              borderRadius: "10px",
              maxWidth: "80%",
              overflowX: "auto",
            }}
          >
            {productImages.map((image, index) => (
              <div
                key={index}
                onClick={(e) => {
                  e.stopPropagation();
                  this.setState({
                    selectedImage: image,
                    activeImageIndex: index,
                  });
                }}
                style={{
                  width: "60px",
                  height: "60px",
                  borderRadius: "6px",
                  overflow: "hidden",
                  cursor: "pointer",
                  border:
                    image === this.state.selectedImage
                      ? "2px solid #88c000"
                      : "2px solid transparent",
                  opacity: image === this.state.selectedImage ? 1 : 0.6,
                  transition: "all 0.3s ease",
                  flexShrink: 0,
                }}
                onMouseEnter={(e) => {
                  if (image !== this.state.selectedImage) {
                    e.currentTarget.style.opacity = "0.8";
                    e.currentTarget.style.borderColor =
                      "rgba(136, 192, 0, 0.5)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (image !== this.state.selectedImage) {
                    e.currentTarget.style.opacity = "0.6";
                    e.currentTarget.style.borderColor = "transparent";
                  }
                }}
              >
                <img
                  src={PUBLIC_URL(image)}
                  alt={`${product.name} ${index + 1}`}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  render() {
    if (!this.props.product.product) {
      return <Loading text="Ürün Yükleniyor..." />;
    }

    const { product } = this.props.product;
    const { setting } = this.props;
    const { selectedImage } = this.state;

    const discount = activeDiscount(product.categories);
    const finalPrice = product.sale_price || product.price;
    const discountedPrice = discount
      ? discount.type === "percent"
        ? finalPrice * (1 - discount.discount / 100)
        : finalPrice - discount.discount
      : null;

    // Combine main image with additional images
    const allImages = [];
    if (product.image) {
      allImages.push(product.image);
    }
    if (product.images && Array.isArray(product.images)) {
      product.images.forEach((img) => {
        if (img && img !== product.image) {
          allImages.push(img);
        }
      });
    }
    const productImages = allImages.length > 0 ? allImages : [product.image];
    const displayImage = selectedImage || product.image;

    // SEO data for product page
    const productPageSEO = {
      title: generatePageTitle(
        "product",
        product,
        setting && setting.setting && setting.setting.title
      ),
      description: generateMetaDescription(
        "product",
        product,
        setting && setting.setting && setting.setting.title
      ),
      keywords: generateKeywords("product", product, [
        "satın al",
        "fiyat",
        "online",
      ]),
      type: "product",
      url: `/urun/${product.slug}`,
      canonical: generateCanonicalUrl("product", product),
      breadcrumbs: generateBreadcrumbs("product", product),
      image: PUBLIC_URL(product.image),
      product: {
        ...product,
        price: discountedPrice || finalPrice,
      },
    };

    return (
      <React.Fragment>
        <SEO {...productPageSEO} />
        {this.renderLightbox()}

        {/* Breadcrumb */}
        <div className="container" style={{ marginTop: "20px" }}>
          <div
            style={{
              fontSize: "14px",
              color: "#6c757d",
            }}
          >
            <Link to="/" style={{ color: "#6c757d", textDecoration: "none" }}>
              Ana Sayfa
            </Link>
            <span style={{ margin: "0 8px", color: "#dee2e6" }}>/</span>
            {product.categories && product.categories.length > 0 && (
              <React.Fragment>
                <Link
                  to={`/kategori/${product.categories[0].slug}`}
                  style={{ color: "#6c757d", textDecoration: "none" }}
                >
                  {product.categories[0].title}
                </Link>
                <span style={{ margin: "0 8px", color: "#dee2e6" }}>/</span>
              </React.Fragment>
            )}
            <span style={{ color: "#212529", fontWeight: "500" }}>
              {product.name}
            </span>
          </div>
        </div>

        {/* Main Product Section */}
        <div className="container" style={{ marginTop: "30px" }}>
          <div className="row">
            {/* Main Content Area */}
            <div className="col-lg-9">
              {/* Product Display Section */}
              <div className="row" style={{ marginBottom: "40px" }}>
                {/* Left - Main Image with thumbnails below */}
                <div className="col-md-6">
                  {/* Main Image */}
                  <div
                    style={{
                      backgroundColor: "#fff",
                      border: "1px solid #dee2e6",
                      borderRadius: "8px",
                      padding: "20px",
                      textAlign: "center",
                      minHeight: "400px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative",
                      marginBottom: "15px",
                    }}
                  >
                    {/* Only Discount Badge on Image */}
                    {discount && discount.discount > 0 ? (
                      <div
                        style={{
                          position: "absolute",
                          top: "15px",
                          left: "15px",
                          backgroundColor: "#dc3545",
                          color: "white",
                          padding: "6px 12px",
                          borderRadius: "20px",
                          fontSize: "12px",
                          fontWeight: "600",
                          zIndex: 2,
                        }}
                      >
                        %
                        {discount.type === "percent"
                          ? discount.discount
                          : Math.round(
                              (discount.discount / product.price) * 100
                            )}{" "}
                        İNDİRİM
                      </div>
                    ) : null}
                    <img
                      src={PUBLIC_URL(displayImage)}
                      alt={generateAltText("product", product)}
                      onClick={this.openLightbox}
                      style={{
                        maxWidth: "100%",
                        maxHeight: "350px",
                        objectFit: "contain",
                        cursor: "zoom-in",
                      }}
                    />
                  </div>

                  {/* Thumbnail Gallery */}
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      justifyContent: "center",
                      flexWrap: "wrap",
                      marginTop: "10px",
                    }}
                  >
                    {productImages.slice(0, 5).map((image, index) => {
                      if (!image) return null;
                      return (
                        <div
                          key={index}
                          onClick={() => this.selectImage(image, index)}
                          style={{
                            width: "80px",
                            height: "80px",
                            border:
                              this.state.activeImageIndex === index
                                ? "2px solid #88c000"
                                : "1px solid #dee2e6",
                            borderRadius: "4px",
                            overflow: "hidden",
                            cursor: "pointer",
                            backgroundColor: "white",
                            padding: "5px",
                            transition: "all 0.2s ease",
                          }}
                          onMouseEnter={(e) => {
                            if (this.state.activeImageIndex !== index) {
                              e.currentTarget.style.borderColor = "#88c000";
                              e.currentTarget.style.opacity = "0.8";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (this.state.activeImageIndex !== index) {
                              e.currentTarget.style.borderColor = "#dee2e6";
                              e.currentTarget.style.opacity = "1";
                            }
                          }}
                        >
                          <img
                            src={PUBLIC_URL(image)}
                            alt={`${product.name} ${index + 1}`}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                            }}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>

                {/* Right - Product Info */}
                <div className="col-md-6">
                  <div style={{ padding: "0 20px" }}>
                    {/* Category */}
                    <div
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                        color: "#6c757d",
                        marginBottom: "10px",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                      }}
                    >
                      {product.categories &&
                        product.categories[0] &&
                        product.categories[0].title}
                    </div>

                    {/* Product Title */}
                    <h1
                      style={{
                        fontSize: "28px",
                        fontWeight: "300",
                        color: "#212529",
                        marginBottom: "10px",
                        lineHeight: "1.3",
                      }}
                    >
                      {product.name}
                    </h1>

                    {/* Low Stock Warning */}
                    {product.stock &&
                    product.stock <= (product.lowStockThreshold || 5) &&
                    product.stock > 0 ? (
                      <div
                        style={{
                          fontSize: "14px",
                          color: "#dc3545",
                          fontWeight: "600",
                          marginBottom: "20px",
                        }}
                      >
                        <span
                          style={{
                            animation: "smoothBlink 2s infinite",
                            animationTimingFunction: "ease-in-out",
                          }}
                        >
                          ⚠️ Son {product.stock} adet kaldı!
                        </span>
                        <style>
                          {`
                            @keyframes smoothBlink {
                              0% { opacity: 1; }
                              25% { opacity: 0.7; }
                              50% { opacity: 0.5; }
                              75% { opacity: 0.7; }
                              100% { opacity: 1; }
                            }
                          `}
                        </style>
                      </div>
                    ) : null}

                    {/* Price */}
                    <div style={{ marginBottom: "20px" }}>
                      {/* Price with Discount Badge */}
                      {(discount && discount.discount > 0) ||
                      product.sale_price ? (
                        <div
                          style={{
                            display: "flex",
                            // alignItems: "center",
                            gap: "15px",
                          }}
                        >
                          {/* Discount Badge */}
                          <div
                            style={{
                              backgroundColor: "#88c000",
                              color: "white",
                              padding: "8px 12px",
                              borderRadius: "8px",
                              fontSize: "16px",
                              fontWeight: "700",
                              minWidth: "60px",
                              textAlign: "center",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            %
                            {(() => {
                              // VibrantProductCard ile aynı mantık: sadece sale_price varsa indirim var
                              if (!product.sale_price) return 0;
                              const discountPercent =
                                ((product.price - product.sale_price) /
                                  product.price) *
                                100;
                              return Math.round(discountPercent);
                            })()}
                          </div>

                          {/* Prices */}
                          <div>
                            {/* Original Price (crossed out) */}
                            <div
                              style={{
                                fontSize: "14px",
                                color: "#999",
                                textDecoration: "line-through",
                                marginBottom: "2px",
                              }}
                            >
                              {product.price.toFixed(2)} ₺
                            </div>

                            {/* Final Price */}
                            <div
                              style={{
                                fontSize: "28px",
                                fontWeight: "800",
                                color: "#212529",
                                lineHeight: "1",
                              }}
                            >
                              {parseFloat(
                                discount && discount.discount > 0
                                  ? product.sale_price
                                    ? discount.type === "percent"
                                      ? product.sale_price *
                                        (1 - discount.discount / 100)
                                      : product.sale_price - discount.discount
                                    : discount.type === "percent"
                                    ? product.price *
                                      (1 - discount.discount / 100)
                                    : product.price - discount.discount
                                  : product.sale_price
                              ).toFixed(2)}{" "}
                              ₺
                            </div>
                          </div>
                        </div>
                      ) : (
                        /* No Discount - Regular Price */
                        <div
                          style={{
                            fontSize: "36px",
                            fontWeight: "700",
                            color: "#212529",
                            lineHeight: "1",
                          }}
                        >
                          ₺{product.price.toFixed(2)}
                        </div>
                      )}
                    </div>

                    {/* Product Badges */}
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "10px",
                        marginBottom: "20px",
                      }}
                    >
                      {/* Best Seller Badge */}
                      {product.isBestSeller ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            backgroundColor: "#fff9e6",
                            color: "#b8860b",
                            border: "1px solid #f0c14b",
                            padding: "8px 14px",
                            borderRadius: "16px",
                            fontSize: "12px",
                            fontWeight: "600",
                            textTransform: "uppercase",
                            letterSpacing: "0.3px",
                          }}
                        >
                          <FontAwesomeIcon
                            icon={["fas", "star"]}
                            style={{ fontSize: "10px" }}
                          />
                          ÇOK SATAN
                        </div>
                      ) : null}

                      {/* New Product Badge */}
                      {product.isNewProduct ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            backgroundColor: "#f0fff4",
                            color: "#28a745",
                            border: "1px solid #90ee90",
                            padding: "8px 14px",
                            borderRadius: "16px",
                            fontSize: "12px",
                            fontWeight: "600",
                            textTransform: "uppercase",
                            letterSpacing: "0.3px",
                          }}
                        >
                          <FontAwesomeIcon
                            icon={["fas", "sparkles"]}
                            style={{ fontSize: "10px" }}
                          />
                          YENİ ÜRÜN
                        </div>
                      ) : null}

                      {/* Deal Product Badge */}
                      {product.isDeal ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            backgroundColor: "#fff5f0",
                            color: "#ff6b35",
                            border: "1px solid #ffb088",
                            padding: "8px 14px",
                            borderRadius: "16px",
                            fontSize: "12px",
                            fontWeight: "600",
                            textTransform: "uppercase",
                            letterSpacing: "0.3px",
                          }}
                        >
                          <FontAwesomeIcon
                            icon={["fas", "fire"]}
                            style={{ fontSize: "10px" }}
                          />
                          FIRSAT
                        </div>
                      ) : null}

                      {/* Free Shipping Badge */}
                      {(() => {
                        const finalPrice = product.sale_price || product.price;
                        const freeShippingLimit =
                          this.props.setting &&
                          this.props.setting.setting &&
                          this.props.setting.setting.free_shipping
                            ? this.props.setting.setting.free_shipping
                            : 350;
                        return finalPrice && finalPrice >= freeShippingLimit;
                      })() ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            backgroundColor: "#e8f5e8",
                            color: "#198754",
                            border: "1px solid #a3cfbb",
                            padding: "8px 14px",
                            borderRadius: "16px",
                            fontSize: "12px",
                            fontWeight: "600",
                            textTransform: "uppercase",
                            letterSpacing: "0.3px",
                          }}
                        >
                          <FontAwesomeIcon
                            icon={["fas", "truck"]}
                            style={{ fontSize: "10px" }}
                          />
                          ÜCRETSİZ KARGO
                        </div>
                      ) : null}
                    </div>

                    {/* Quantity and Add to Cart */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "15px",
                        marginBottom: "25px",
                      }}
                    >
                      {/* Quantity Selector */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          border: "1px solid #dee2e6",
                          borderRadius: "4px",
                          backgroundColor: "white",
                        }}
                      >
                        <button
                          onClick={() => this.handleQuantityChange("decrease")}
                          style={{
                            width: "40px",
                            height: "40px",
                            border: "none",
                            backgroundColor: "transparent",
                            cursor: "pointer",
                            fontSize: "18px",
                            color: "#6c757d",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          disabled={this.state.quantity <= 1}
                        >
                          −
                        </button>
                        <div
                          style={{
                            width: "50px",
                            height: "40px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "16px",
                            fontWeight: "600",
                            borderLeft: "1px solid #dee2e6",
                            borderRight: "1px solid #dee2e6",
                          }}
                        >
                          {this.state.quantity}
                        </div>
                        <button
                          onClick={() => this.handleQuantityChange("increase")}
                          style={{
                            width: "40px",
                            height: "40px",
                            border: "none",
                            backgroundColor: "transparent",
                            cursor: "pointer",
                            fontSize: "18px",
                            color: "#6c757d",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          disabled={
                            this.state.quantity >= (product.stock || 999)
                          }
                        >
                          +
                        </button>
                      </div>

                      {/* Add to Cart Button */}
                      <button
                        onClick={this.handleAddToCart}
                        disabled={
                          !product.stock ||
                          product.stock === 0 ||
                          !product.price ||
                          product.price === 0
                        }
                        style={{
                          flex: 1,
                          padding: "15px 30px",
                          backgroundColor:
                            !product.stock || product.stock === 0
                              ? "#9ca3af"
                              : !product.price || product.price === 0
                              ? "#9ca3af"
                              : "#88c000",
                          color: "white",
                          border: "none",
                          borderRadius: "8px",
                          fontSize: "16px",
                          fontWeight: "600",
                          cursor:
                            !product.stock ||
                            product.stock === 0 ||
                            !product.price ||
                            product.price === 0
                              ? "default"
                              : "pointer",
                          textTransform: "uppercase",
                          transition: "all 0.3s ease",
                          letterSpacing: "0.5px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "8px",
                          opacity:
                            !product.stock ||
                            product.stock === 0 ||
                            !product.price ||
                            product.price === 0
                              ? 0.6
                              : 1,
                        }}
                        onMouseEnter={(e) => {
                          if (
                            product.stock &&
                            product.stock > 0 &&
                            product.price &&
                            product.price > 0
                          ) {
                            e.target.style.backgroundColor = "#66cc33";
                            e.target.style.transform = "scale(1.02)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (
                            product.stock &&
                            product.stock > 0 &&
                            product.price &&
                            product.price > 0
                          ) {
                            e.target.style.backgroundColor = "#88c000";
                            e.target.style.transform = "scale(1)";
                          }
                        }}
                      >
                        <FontAwesomeIcon
                          icon={[
                            "fas",
                            !product.stock || product.stock === 0
                              ? "times-circle"
                              : !product.price || product.price === 0
                              ? "info-circle"
                              : "shopping-cart",
                          ]}
                        />
                        {!product.stock || product.stock === 0
                          ? "STOKTA YOK"
                          : !product.price || product.price === 0
                          ? "FİYAT YOK"
                          : "SEPETE EKLE"}
                      </button>
                    </div>

                    {/* Share Options */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        marginBottom: "25px",
                      }}
                    >
                      <span style={{ fontSize: "14px", color: "#6c757d" }}>
                        Paylaş:
                      </span>
                      <button
                        onClick={() => {
                          const text = `${product.name} - ${window.location.origin}/urun/${product.slug}`;
                          window.open(
                            `https://wa.me/?text=${encodeURIComponent(text)}`,
                            "_blank"
                          );
                        }}
                        style={{
                          background: "#25D366",
                          border: "none",
                          borderRadius: "50%",
                          width: "36px",
                          height: "36px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.opacity = "0.8";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.opacity = "1";
                        }}
                      >
                        <FontAwesomeIcon
                          icon={["fab", "whatsapp"]}
                          style={{ color: "white", fontSize: "18px" }}
                        />
                      </button>

                      <button
                        onClick={() => {
                          const url = window.location.href;
                          const text = `${product.name}`;
                          window.open(
                            `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                              url
                            )}&quote=${encodeURIComponent(text)}`,
                            "_blank"
                          );
                        }}
                        style={{
                          background: "#1877f2",
                          border: "none",
                          borderRadius: "50%",
                          width: "36px",
                          height: "36px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.opacity = "0.8";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.opacity = "1";
                        }}
                      >
                        <FontAwesomeIcon
                          icon={["fab", "facebook-f"]}
                          style={{ color: "white", fontSize: "18px" }}
                        />
                      </button>

                      <button
                        onClick={() => {
                          window.open(`https://www.instagram.com/`, "_blank");
                        }}
                        style={{
                          background:
                            "linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%)",
                          border: "none",
                          borderRadius: "50%",
                          width: "36px",
                          height: "36px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.opacity = "0.8";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.opacity = "1";
                        }}
                      >
                        <FontAwesomeIcon
                          icon={["fab", "instagram"]}
                          style={{ color: "white", fontSize: "18px" }}
                        />
                      </button>

                      <button
                        onClick={() => {
                          const url = window.location.href;
                          const text = `${product.name} - ${url}`;
                          window.open(
                            `https://twitter.com/intent/tweet?text=${encodeURIComponent(
                              text
                            )}`,
                            "_blank"
                          );
                        }}
                        style={{
                          background: "#1da1f2",
                          border: "none",
                          borderRadius: "50%",
                          width: "36px",
                          height: "36px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.opacity = "0.8";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.opacity = "1";
                        }}
                      >
                        <FontAwesomeIcon
                          icon={["fab", "twitter"]}
                          style={{ color: "white", fontSize: "18px" }}
                        />
                      </button>
                    </div>

                    {/* Features Grid - Below Add to Cart */}
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(2, 1fr)",
                        gap: "15px",
                        marginTop: "25px",
                        paddingTop: "25px",
                        borderTop: "1px solid #e5e7eb",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <div
                          style={{
                            width: "40px",
                            height: "40px",
                            backgroundColor: "#f0f8e8",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                          }}
                        >
                          <FontAwesomeIcon
                            icon={["fas", "truck"]}
                            style={{ color: "#88c000", fontSize: "16px" }}
                          />
                        </div>
                        <div>
                          <div
                            style={{
                              fontSize: "12px",
                              fontWeight: "600",
                              color: "#212529",
                            }}
                          >
                            Ücretsiz Kargo
                          </div>
                          <div style={{ fontSize: "10px", color: "#6c757d" }}>
                            {this.props.setting &&
                            this.props.setting.setting &&
                            this.props.setting.setting.free_shipping
                              ? `${this.props.setting.setting.free_shipping}TL ve üzeri sipariş`
                              : "350TL ve üzeri sipariş"}
                          </div>
                        </div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <div
                          style={{
                            width: "40px",
                            height: "40px",
                            backgroundColor: "#f0f8e8",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                          }}
                        >
                          <FontAwesomeIcon
                            icon={["fas", "clock"]}
                            style={{ color: "#88c000", fontSize: "16px" }}
                          />
                        </div>
                        <div>
                          <div
                            style={{
                              fontSize: "12px",
                              fontWeight: "600",
                              color: "#212529",
                            }}
                          >
                            Aynı Gün Kargo
                          </div>
                          <div style={{ fontSize: "10px", color: "#6c757d" }}>
                            {this.props.setting &&
                            this.props.setting.setting &&
                            this.props.setting.setting.same_day_shipping_hour
                              ? `${this.props.setting.setting.same_day_shipping_hour}'a kadar sipariş`
                              : "16:00'a kadar sipariş"}
                          </div>
                        </div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <div
                          style={{
                            width: "40px",
                            height: "40px",
                            backgroundColor: "#f0f8e8",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                          }}
                        >
                          <FontAwesomeIcon
                            icon={["fas", "undo"]}
                            style={{ color: "#88c000", fontSize: "16px" }}
                          />
                        </div>
                        <div>
                          <div
                            style={{
                              fontSize: "12px",
                              fontWeight: "600",
                              color: "#212529",
                            }}
                          >
                            Kolay İade
                          </div>
                          <div style={{ fontSize: "10px", color: "#6c757d" }}>
                            14 gün iade garantisi
                          </div>
                        </div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <div
                          style={{
                            width: "40px",
                            height: "40px",
                            backgroundColor: "#f0f8e8",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                          }}
                        >
                          <FontAwesomeIcon
                            icon={["fas", "shield-alt"]}
                            style={{ color: "#88c000", fontSize: "16px" }}
                          />
                        </div>
                        <div>
                          <div
                            style={{
                              fontSize: "12px",
                              fontWeight: "600",
                              color: "#212529",
                            }}
                          >
                            Güvenli Ödeme
                          </div>
                          <div style={{ fontSize: "10px", color: "#6c757d" }}>
                            SSL sertifika koruması
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Product Information */}
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div
                      className="card-header"
                      style={{ backgroundColor: "#f8f9fa", border: "none" }}
                    >
                      <h5
                        className="mb-0"
                        style={{ color: "#212529", fontWeight: "600" }}
                      >
                        Ürün Hakkında
                      </h5>
                    </div>
                    <div className="card-body" style={{ padding: "30px" }}>
                      <div
                        className="card-text"
                        style={{
                          fontSize: "15px",
                          lineHeight: "1.8",
                          color: "#333",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(
                            product.content ||
                            "Ürün açıklaması henüz eklenmemiş."
                          ),
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Sidebar */}
            <div className="col-lg-3">
              <CartWidget />
              <CategoriesWidget />
              <BlogWidget />
            </div>
          </div>
        </div>

        {/* Similar Products */}
        {this.props.product.similarProducts &&
          this.props.product.similarProducts.length > 0 && (
            <div
              style={{
                backgroundColor: "#f8f9fa",
                padding: "60px 0",
                marginTop: "60px",
              }}
            >
              <div className="container">
                <h2
                  style={{
                    fontSize: "28px",
                    fontWeight: "600",
                    color: "#212529",
                    textAlign: "center",
                    marginBottom: "40px",
                  }}
                >
                  Benzer Ürünler
                </h2>
                <div className="row">
                  {this.props.product.similarProducts
                    .slice(0, 4)
                    .map((similarProduct, index) => (
                      <div
                        key={similarProduct.id || index}
                        className="col-md-3 mb-4"
                      >
                        <VibrantProductCard {...similarProduct} />
                      </div>
                    ))}
                </div>
              </div>
            </div>
          )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ setting, category, product }) => {
  return { setting, category, product };
};

const mapDispatchToProps = {
  setProduct,
  getProductBySlug,
  getSimilarProducts,
  addCart,
};

export default connect(mapStateToProps, mapDispatchToProps)(Product);



// WEBPACK FOOTER //
// ./src/routers/Product/index.js